import {
  UPDATE_PI_ADD_VALIDATION_LISTENER,
  UPDATE_PI_LOADED,
  UPDATE_PI_REMOVE_VALIDATION_LISTENER, UPDATE_PI_VALIDATE_RESULT,
  UPDATE_PI_VALIDATION_RESULT
} from "./UpdatePiActions";

const initialState = {
  loaded: false,
  widgetRef: null,
  validationResult: null,
  validationListenerAdded: false,
  validateResult: null
};

export function updatePi(state = initialState, action) {
  switch (action.type) {
    case UPDATE_PI_LOADED:
      return {
        ...state,
        loaded: true,
        widgetRef: action.value
      };
    case UPDATE_PI_VALIDATION_RESULT:
      return {
        ...state,
        validationResult: action.value
      };
    case UPDATE_PI_VALIDATE_RESULT:
      return {
        ...state,
        validateResult: action.value
      }
    case UPDATE_PI_ADD_VALIDATION_LISTENER:
      return {
        ...state,
        validationListenerAdded: true
      };
    case UPDATE_PI_REMOVE_VALIDATION_LISTENER:
      return {
        ...state,
        validationListenerAdded: false
      };
    default:
      return state;
  }
}

export const isUpdatePiLoaded = state => {
  return state.updatePi.loaded;
};

export const getWidgetRef = state => {
  return state.updatePi.widgetRef;
};



// WEBPACK FOOTER //
// ./src/update-pi/UpdatePiReducer.js